var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import {} from "../../actions.mjs";
import { elementInstance } from "../instance.mjs";
import { getCountries } from "../../atlas.mjs";
import { getShippingAddress } from "./utils.mjs";
import { shippingAddressElementId } from "./elements.mjs";
let currentElement = undefined;
export const getCurrentShippingAddressElement = () => currentElement;
export const initializeStripeShippingAddressElements = (state, actions, elements) => {
    elementInstance({
        elementId: shippingAddressElementId,
        idempotencyKey: state.id + elements.id,
        onMount: (e) => __awaiter(void 0, void 0, void 0, function* () {
            const element = yield getOrCreateShippingAddressElement(state, elements);
            element.mount(e);
            currentElement = element;
            element.on('change', (event) => {
                const countryCode = event.value.address.country.toLowerCase();
                if (state.countryCode.toLowerCase() !== countryCode) {
                    state.update({ countryCode });
                    actions.reload();
                }
            });
            element.on('blur', () => {
                // We use setTimeout to ensure the new address value is available after using
                // autocomplete. In this flow, the blur event fires before the change event,
                // so we need to delay reading the value. On very slow connections, the latest
                // address might still not be available, but this is handled later in
                // setCompletePurchaseHandler (in paymentElements.ts), where the latest value
                // is read again before attempting to submit the order.
                setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
                    const details = yield element.getValue();
                    const address = getShippingAddress(details);
                    yield actions.setAddress(address);
                }), 500);
            });
            return () => {
                element.unmount();
                currentElement = undefined;
            };
        }),
    });
};
const getShippingAddressElement = (elements) => {
    return elements.getElement('address', { mode: 'shipping' });
};
const getOrCreateShippingAddressElement = (state, elements) => __awaiter(void 0, void 0, void 0, function* () {
    const existingElement = getShippingAddressElement(elements);
    if (existingElement) {
        return existingElement;
    }
    const countryCodes = yield getCountryCodes(state);
    return createShippingAddressElement(state, elements, countryCodes);
});
const createShippingAddressElement = (state, elements, allowedCountries) => {
    return elements.create('address', {
        mode: 'shipping',
        allowedCountries,
        display: {
            name: 'split',
        },
        defaultValues: state.customer.address && {
            firstName: state.customer.address.firstName,
            lastName: state.customer.address.lastName,
            address: {
                country: state.countryCode.toUpperCase(),
                line1: state.customer.address.address1,
                line2: state.customer.address.address2,
                city: state.customer.address.city,
                state: state.customer.address.stateOrProvince,
                postal_code: state.customer.address.postalCode,
            },
        },
    });
};
const getCountryCodes = (state) => __awaiter(void 0, void 0, void 0, function* () {
    if (state.orderId && state.countryCode) {
        // If this is a manual order, we only allow the country that was used when creating the order
        return [state.countryCode.toUpperCase()];
    }
    const response = yield getCountries(state)();
    return response.shippingCountries.filter(({ active }) => active).map(({ code }) => code);
});
//# sourceMappingURL=shippingAddressElements.js.map